export default __webpack_public_path__ + "static/media/look360.f2e2cd02.png";